import { render, staticRenderFns } from "./ModalChangeLog.vue?vue&type=template&id=04003898&"
import script from "./ModalChangeLog.vue?vue&type=script&lang=js&"
export * from "./ModalChangeLog.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeLog.vue?vue&type=style&index=0&id=04003898&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports